import React from 'react';
import { Route } from 'react-router';
import Auth from './index';
import Logout from './components/Logout';

export default (
  <Route key="auth-route">
    <Route key="login-route" path="login" components={{ content: Auth }} />
    <Route key="logout-route" path="logout" components={{ content: Logout }} />
  </Route>
);



// WEBPACK FOOTER //
// ./src/modules/auth/routes.jsx